import { 
  axios_mock, 
  axios_live 
} from 'utilities/axios.instances'

//━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
export const fetcher_mock = async (...args) => {
  try {
    const res = await axios_mock.get(...args)
    return res.data
  } catch (err) {
    errLog(args, err)
    throw err // Rethrow the error to propagate it
  }
}

//━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
export const fetcher = async (...args) => {
  try {
    const res = await axios_live.get(...args)
    return res.data
  } catch (err) {
    errLog(args, err)
    throw err // Rethrow the error to propagate it
  }
}

//━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
const errLog = (args, err) => {
  console.log(
    '━━━━━━━━━━━━' 
    + '\nAxios_Error'
    + '\n' + args
    + '\n' + err
    + '\n━━━━━━━━━━━━\n'
  )
}
